export default __webpack_public_path__ + "static/media/yd-head.49343e2f.png";